<div class="modal-header bg-light">
    @switch (tipoReporte) {
      @case (TipoReporteRefacturacion.Manual) { <h4 class="modal-title">Solicitud de Refacturaci&oacute;n manual </h4> }
      @case (TipoReporteRefacturacion.Devolucion) { <h4 class="modal-title">Solicitud de Refacturaci&oacute;n por devoluci&oacute;n de litros </h4> }
      @default { <h4 class="modal-title">Correcci&oacute;n de despacho </h4> }
    }
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
  <form [formGroup]="form">
    <div class="modal-body">
      @if (tipoReporte === TipoReporteRefacturacion.Manual){
        <div class="row">
          <div class="mb-3 row col-md-12">
            <label class="col-sm-5 col-form-label" for="motivoFormControl">*Motivo:</label>
            <div class="col-sm-7">
              <select id="motivoFormControl" class="form-select" ngbTooltip="Seleccione un motivo."
                      formControlName="motivoFormControl">
                <option *ngFor="let m of this.keysTipoMotivos()" [ngValue]="motivo[m]">
                  {{ m }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <br>
        @if (seleccionoPlazo){
          <div class="row">
            <div class="mb-3 row col-md-12">
              <label class="col-sm-5 col-form-label">*Plazo d&iacute;as:</label>
              <div class="col-sm-7">
                <input type="number" appOnlyNumber min="0" formControlName="plazoFormControl"
                      class="form-control" maxlength="50">
              </div>
            </div>
          </div>
          <br>
        }
      }
      @if (tipoReporte !== TipoReporteRefacturacion.Devolucion){
        <div class="mb-3 col-10 offset-1 mt-2" style="border: 1px solid #ccc; padding: 1em;">
          <div class="mb-3 row">
            <div class="col-md-11" style="font-weight: bold;">Subir archivo adjunto:</div>
            <div class="col-md-1"></div>
          </div>
          <div class="mb-3 row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <app-upload-file [url]="this.clientesBaseUrl" (archivoSubido)="onArchivoSubido($event)"></app-upload-file>
            </div>
            <div class="col-md-1"></div>
          </div>
        </div>
      }
      <div class="row">
        <div class="mb-3 row col-md-12">
          <label for="comentarioTextArea" class="col-md-5 col-form-label">*Comentarios:</label>
          <div class="col-md-7">
            <textarea id="comentarioTextArea" formControlName="comentariosFormControl" rows="4" cols="27">
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <small class="text-danger"> *Campos obligatorios.</small>
    <div class="modal-footer bg-light">
      @if (error != null){
        <div class="alert alert-danger">{{error}}</div>
      }
      <button class="btn btn-primary me-2" id="aceptar" [disabled]="!this.puedeSolicitarRefactura() || this.guardando"
              (click)="this.onSubmit()">
        @if (!guardando){
          <span>Guardar</span>
        }
        @if (guardando){
          <div class="d-flex align-items-center">
            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
            <span>Guardando...</span>
          </div>
        }
      </button>
      <button type="button" class="btn btn-secondary" [disabled]="guardando"
              (click)="activeModal.dismiss('Close clicked')">Cancelar</button>
    </div>
  </form>
  